import MiniLoader from 'ageas-react-component-miniloader'
import Section from 'ageas-react-component-section'

import { useEffect, useState } from 'react'
import { DocumentToList } from '../../@types/SubmitProposal'
import { useCancelDigitalSignatureProcessStore } from '../../Stores/useCancelDigitalSignatureProcessStore'
import { usePolicyDocumentsSelectedStore } from '../../Stores/usePolicyDocumentsSelectedStore'
import { useRefreshDigitalSignatureStatusStore } from '../../Stores/useRefreshDigitalSignatureStatusStore'
import { useSubmitProposalStore } from '../../Stores/useSubmitProposalStore'
import { t } from '../../i18n'
import { removeDuplicatesDocuments } from '../../utils/validates'
import { SubmitProposalDocuments } from './Documents/SubmitProposalDocuments'
import { DocumentsContainer } from './styles'

type Props = {
  isLoading?: boolean
}

export const PolicyDocumentation = ({ isLoading }: Props) => {
  const [hasCheckUpdate, setHasCheckUpdate] = useState(true)
  const [check, setCheck] = useState<any>()
  const { submitProposal } = useSubmitProposalStore()
  const { policyDocuments } = usePolicyDocumentsSelectedStore()
  const { refreshDigitalSignatureStatus } =
    useRefreshDigitalSignatureStatusStore()
  const { cancelDigitalSignatureProcess } =
    useCancelDigitalSignatureProcessStore()

  const allDocuments = removeDuplicatesDocuments(
    [
      ...(submitProposal?.documents || []),
      ...(refreshDigitalSignatureStatus?.documents || []),
      ...(cancelDigitalSignatureProcess?.documents || []),
    ],
    'keyRef',
  ) as DocumentToList[]

  const hasDocuments = (allDocuments || [])?.length > 0

  const handleCheckbox = (value: any) => {
    setCheck((prev: any) => ({
      ...prev,
      ...value,
    }))
  }

  useEffect(() => {
    if (policyDocuments.length > 0 && hasCheckUpdate) {
      const currentValues = policyDocuments.reduce(
        (acc: any, cur: any) => ({
          ...acc,
          [`ckeck-${cur.keyRef}`]: '1',
        }),
        {},
      )

      setCheck(currentValues)
      setHasCheckUpdate(false)
    }
  }, [policyDocuments, hasCheckUpdate])

  return (
    <>
      {isLoading && (
        <DocumentsContainer>
          <MiniLoader color="white" minHeight="auto" maxWidth="auto" />
        </DocumentsContainer>
      )}
      {!isLoading && hasDocuments && (
        <>
          <Section
            id="confirmation-policy-documentation"
            name={t('pages.step7.policyDocumentation.section')}
            config={{ labelSize: '20px', labelBold: '500' }}
            colorTheme="blue"
          />
          <DocumentsContainer>
            <SubmitProposalDocuments
              check={check}
              handleCheckbox={handleCheckbox}
            />
          </DocumentsContainer>
        </>
      )}
    </>
  )
}
